import { ReactElement } from 'react';

import { BannerImage } from '../components/BannerImage';
import { HirePlanMobileArticleHeader } from '../components/HirePlanForm/mobile/HirePlanMobileArticleHeader';
import { UpdateDepFormSection } from '../components/HirePlanForm/ServidorGDF/UpdateDepFormSection';
import { PageHelmet } from '../components/PageHelmet';

export function UpdateDependentGDFPage(): ReactElement {
  return (
    <div className="overflow-hidden">
      <PageHelmet title="Incluir Dependentes | OdontoGroup" />

      <BannerImage page="plan" imgSource="/assets/images/plan-banner.jpg" />
      <div className="">
        <article className="-mb-20 bg-transparent min-[748px]:-mt-[326px] -mt-[57px] max-w-[1551px] max-[1599px]:px-6 mx-auto">
          <div className="flex 2xl:gap-16 min-[748px]:gap-8 gap-16 max-[1085px]:flex-col">
            <HirePlanMobileArticleHeader />
            <UpdateDepFormSection key="hirePlanFormSection" />
          </div>
        </article>
      </div>
    </div>
  );
}
